import React, {useState} from 'react';
import {Text, TouchableOpacity, View} from 'react-native';
import I18n from 'i18n-js';
import styles, {touchTargetMin} from '../../../style/adminTools';
import {ListEmpty, ListUnavailable} from './ListState';
import {userPillTexts} from './sectionConfig';

const COLLAPSED_COUNT = 5;

const isAdminOnly = user =>
  Boolean(user.role_name) && user.role_name.includes('Administrative');

const roleTag = user => {
  if (!user.role_name) return null;
  return isAdminOnly(user)
    ? I18n.t('customerSettings.userTagAdminOnly')
    : I18n.t('customerSettings.userTagRegular');
};

const UserRow = ({user}) => {
  const tag = roleTag(user);
  return (
    <View
      style={[styles.settingRow, styles.settingRowMain]}
      testID={`user-${user.id}`}
    >
      <Text style={styles.settingLabel}>{user.name || user.username}</Text>
      <Text style={styles.settingSavingText}>{user.role_name}</Text>
      {tag ? (
        <View style={styles.groupBadge}>
          <Text style={styles.groupBadgeText} testID={`user-${user.id}-tag`}>
            {tag}
          </Text>
        </View>
      ) : null}
    </View>
  );
};

const UsersList = ({users}) => {
  const [showAll, setShowAll] = useState(false);
  if (!users) return <ListUnavailable testID="users-unavailable" />;
  const [regularPill, adminPill] = userPillTexts(users);
  const hidden = showAll ? 0 : Math.max(users.rows.length - COLLAPSED_COUNT, 0);
  const visible = showAll ? users.rows : users.rows.slice(0, COLLAPSED_COUNT);
  return (
    <View testID="users-list">
      <View style={[styles.settingRowMain, {flexWrap: 'wrap'}]}>
        <View style={styles.groupBadge}>
          <Text style={styles.groupBadgeText} testID="users-pill-regular">
            {regularPill}
          </Text>
        </View>
        <View style={styles.groupBadge}>
          <Text style={styles.groupBadgeText} testID="users-pill-admin-only">
            {adminPill}
          </Text>
        </View>
      </View>
      {users.rows.length === 0 ? (
        <ListEmpty
          testID="users-empty"
          text={I18n.t('customerSettings.noUsers', {defaultValue: 'No users'})}
        />
      ) : (
        visible.map(user => <UserRow key={user.id} user={user} />)
      )}
      {hidden > 0 ? (
        <TouchableOpacity
          onPress={() => setShowAll(true)}
          accessibilityRole="button"
          style={{minHeight: touchTargetMin, justifyContent: 'center'}}
          testID="users-show-all"
        >
          <Text style={styles.settingLabel}>
            {I18n.t('customerSettings.usersShowAll')}
          </Text>
        </TouchableOpacity>
      ) : null}
    </View>
  );
};

export default UsersList;
